const CurrentPath = document.currentScript.src
var LiveCallRoot = CurrentPath.substr(0, CurrentPath.lastIndexOf("/", CurrentPath.lastIndexOf("/")-1));
LiveCallRoot = LiveCallRoot.substr(0, LiveCallRoot.lastIndexOf('/'))

const GetLiveCallPath = (assetURL) => {
    let resolved;
    if (assetURL.startsWith('./')) {
        resolved = `${LiveCallRoot}/${assetURL.substr(2)}`
    } else if (assetURL.startsWith('/')) {
        resolved = `${LiveCallRoot}/${assetURL.substr(1)}`
    } else if (assetURL.startsWith('data')) {
        resolved = assetURL
    }
    return resolved
}

export default GetLiveCallPath